module.exports = __webpack_public_path__ + "img/jqingzhu.19c35b9d.gif";